const postHostUserImageResponse = (data) => ({
  imagePath: data?.data?.imagePath,
  key: data?.data?.key,
});

export default postHostUserImageResponse;
